import {Carousel, Typography} from '@purpose/ui/components';
import {
  WIDGET_CARD_RADIUS,
  WIDGET_LAYOUT,
  WIDGET_TITLE_SIZE,
  WIDGET_TITLE_WEIGHT
} from '@/utils/constants';
import BenefitCard from './BenefitCard';
import {cn} from '@purpose/ui/lib/utils';
import {widgetColors} from '@purpose/ui/utils';
import BenefitCardsGrid from './BenefitCardsGrid';

const Content = ({
  title,
  titleSize,
  titleWeight,
  radius,
  layout,
  benefits,
  color = 'dark_blue',
  onClick
}: {
  title?: string;
  titleSize: WIDGET_TITLE_SIZE;
  titleWeight: WIDGET_TITLE_WEIGHT;
  radius: WIDGET_CARD_RADIUS;
  layout: WIDGET_LAYOUT;
  benefits?: any[];
  color?: string;
  onClick: (id: number) => () => void;
  fallbackWrapperClassName?: string;
}) => {
  const colorFromMap = widgetColors.find(({value}) => value === color);

  return (
    <div className="flex w-full flex-col gap-4 pt-3">
      {title && (
        <Typography
          className={cn(
            'text-primary-base pl-6',
            {'text-[14px]': titleSize === WIDGET_TITLE_SIZE.small},
            {'text-[16px]': titleSize === WIDGET_TITLE_SIZE.medium},
            {'text-[20px]': titleSize === WIDGET_TITLE_SIZE.large},
            {'font-normal': titleWeight === WIDGET_TITLE_WEIGHT.regular},
            {'font-medium': titleWeight === WIDGET_TITLE_WEIGHT.medium},
            {'font-semibold': titleWeight === WIDGET_TITLE_WEIGHT.bold}
          )}
          style={{
            color: colorFromMap?.color || undefined
          }}
        >
          {title}
        </Typography>
      )}
      {layout == WIDGET_LAYOUT.carousel ? (
        <Carousel
          cardContainerClassName="pl-6"
          nextClassname="-right-6"
          nextButtonClassname="-right-4"
          cardWrapperClassname="!w-[220px] box-content p-0"
          className="overflow-hidden"
          renderCard={card => (
            <BenefitCard
              image={card.image as string}
              title={card.name as string}
              titleSize={titleSize}
              titleWeight={titleWeight}
              radius={radius}
              color={color}
              onClick={onClick(card.id)}
            />
          )}
          cards={benefits || []}
        />
      ) : (
        <BenefitCardsGrid
          color={color}
          radius={radius}
          onClick={onClick}
          benefits={benefits}
          titleSize={titleSize}
          titleWeight={titleWeight}
        />
      )}
    </div>
  );
};

export default Content;
